import { Grid, Typography } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import BlockWithTitle from '../../../components/atom/BlockWithTitle';
import { doSwaggerCall } from '../../../hooks/useApi';
import useNotify from '../../../hooks/useNotify';
import { TABLE_ROW_COUNT_DEFAULT } from '../../../helpers/constants';
import { USER_PARKINGS_COLUMNS } from '../../../helpers/tableColumnLists';
import GenericTable from '../../../components/atom/GenericTable';
import handleNavigation from '../../../helpers/handleNavigation';
import { parkingTicketRow } from '../../parkings/parkingFormat';

// parkings of the user, latest entry first (shown next to the user's data)
const ParkingDetails = ({ userId }) => {
    const { notifyError } = useNotify();
    const location = useLocation();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [{ limit, page }, setParams] = useState({ limit: TABLE_ROW_COUNT_DEFAULT, page: 0 });
    const [parkings, setParkings] = useState(null);

    useEffect(() => {
        setLoading(true);
        doSwaggerCall('ParkingTickets', 'getParkingTickets', {
            offset: page * limit,
            limit,
            searchUserId: userId,
            sortby: 'entryTime',
            sortorder: 'DESC',
        })
            .then((res) => setParkings(res))
            .catch(notifyError)
            .finally(() => setLoading(false));
    }, [page, limit, userId]);

    const rows = useMemo(() => (parkings?.tickets || []).map(parkingTicketRow), [parkings]);

    return (
        <Grid item xs={6}>
            <BlockWithTitle title="Parkolások">
                {loading || rows.length ? (
                    <GenericTable
                        rows={rows}
                        limit={limit}
                        page={page}
                        setParams={setParams}
                        loading={loading}
                        total={parkings?.total}
                        columns={USER_PARKINGS_COLUMNS}
                        cellPadding="normal"
                        size="small"
                        onRowClick={(row) =>
                            handleNavigation(location, (stateObj) => {
                                navigate(
                                    `/parkings/details/${encodeURIComponent(row.id)}`,
                                    stateObj
                                );
                            })
                        }
                    />
                ) : (
                    <Grid item xs={12}>
                        <Typography variant="body2" color="text.secondary">
                            Nincs parkolása.
                        </Typography>
                    </Grid>
                )}
            </BlockWithTitle>
        </Grid>
    );
};

export default ParkingDetails;
